export function getDateObjectFromDetails({ dateInString, timeInString }) {
  const [dayOfMonth, monthNumber, yearNumber] = dateInString.split(' ')[0].split('-');
  const [hours, minutes, seconds = '00'] = timeInString.split(':');
  const dateObject = new Date(`${yearNumber}-${monthNumber}-${dayOfMonth}T${hours}:${minutes}:${seconds}`);
  return dateObject;
}

export function getRemainingTimeInHoursAndMinutes(toDateObject, fromDateObject, suffix = 'hours') {
  const NUMBER_OF_MILLI_SECONDS_PER_HOUR = 3600000;
  const NUMBER_OF_MILLI_SECONDS_PER_MINUTE = 60000;
  const ADJUST_NEGATIVE_VALUES_FOR_LATE_TRAINS = 0;
  const differenceInMilliSeconds = Math.max(ADJUST_NEGATIVE_VALUES_FOR_LATE_TRAINS, toDateObject - fromDateObject);
  const numberOfHours = Math.floor(differenceInMilliSeconds / NUMBER_OF_MILLI_SECONDS_PER_HOUR);
  const numberOfMinutesInMilliSeconds = differenceInMilliSeconds - numberOfHours * NUMBER_OF_MILLI_SECONDS_PER_HOUR;
  const numberOfMinutes = Math.floor(numberOfMinutesInMilliSeconds / NUMBER_OF_MILLI_SECONDS_PER_MINUTE);
  return `${numberOfHours.toString().padStart(2, '0')}:${numberOfMinutes.toString().padStart(2, '0')} ${suffix}`;
}

export function formatDateForLtsApiRequest(dateObject) {
  const formattedDate = `${dateObject.getDate().toString().padStart(2, '0')}-${(dateObject.getMonth() + 1)
    .toString()
    .padStart(2, '0')}-${dateObject.getFullYear()}`;
  return formattedDate;
}

export function formatDateForLtsApiResponse(trainStartDate) {
  if (trainStartDate === undefined) {
    return `${formatDateForLtsApiRequest(new Date())} 00:00:00`;
  } else {
    return `${trainStartDate} 00:00:00`;
  }
}
